<!-- container-xxl -->
<div class="content-wrapper p-0">
	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<div class="content-body">
		<!-- app e-commerce details start -->
		<section class="app-ecommerce-details">
			<!-- <div class="card"> -->
				<!-- Related Products starts -->
				<div>
					<div id="stepper1" class="bs-stepper horizontal-wizard-example">
						<div class="bs-stepper-header">
							<div class="step" data-target="#format1">
								<button class="step-trigger">
									<!-- <span class="bs-stepper-box">1</span> -->
									<span class="bs-stepper-label">
										<span class="bs-stepper-title">Proposal Format</span>
										<!-- <span class="bs-stepper-subtitle"
											>Setup Proposal Format 1</span> -->
									</span>
								</button>
							</div>
							<!-- <div class="line">
								<i data-feather="chevron-right" class="font-medium-2"></i>
							</div> -->
							<!-- <div class="step" data-target="#format2">
								<button class="step-trigger">
									<span class="bs-stepper-box">2</span>
									<span class="bs-stepper-label">
										<span class="bs-stepper-title">Proposal Format - 2</span>
										<span class="bs-stepper-subtitle"
											>Setup Proposal Format - 2</span
										>
									</span>
								</button>
							</div> -->
							<!-- <div class="line">
								<i data-feather="chevron-right" class="font-medium-2"></i>
							</div> -->
							<!-- <div class="step" data-target="#format3">
								<button class="step-trigger">
									<span class="bs-stepper-box">3</span>
									<span class="bs-stepper-label">
										<span class="bs-stepper-title">Proposal Format - 3</span>
										<span class="bs-stepper-subtitle"
											>Setup Proposal Format - 3</span
										>
									</span>
								</button>
							</div> -->
							<!-- <div class="line">
								<i data-feather="chevron-right" class="font-medium-2"></i>
							</div> -->
							<!-- <div class="step" data-target="#format4">
								<button class="step-trigger">
									<span class="bs-stepper-box">4</span>
									<span class="bs-stepper-label">
										<span class="bs-stepper-title">Proposal Format - 4</span>
										<span class="bs-stepper-subtitle"
											>Setup Proposal Format - 4</span
										>
									</span>
								</button>
							</div> -->
							<div class="line">
								<i data-feather="chevron-right" class="font-medium-2"></i>
							</div>
							<!-- <div class="step" data-target="#format5">
				<button class="step-trigger">
					<span class="bs-stepper-box">5</span>
					<span class="bs-stepper-label">
					<span class="bs-stepper-title">Proposal Format - 5</span>
					<span class="bs-stepper-subtitle">Setup Proposal Format - 5</span>
					</span>
				</button>
				</div> -->
						</div>
						
						<div class="bs-stepper-content">
							<div id="format1" class="content">
								<form [formGroup]="format1" autocomplete="off">
									<!-- <div class="content-header">
					<h5 class="mb-0">Proposal Format - 1</h5>
					<small class="text-muted">Fill-up the Details.</small>
					</div> -->
					<fieldset class="border" style="padding: 0.7rem">
						<legend class="w-auto">
							<h5 style="margin-top: 7px">EU-TTC Call for Proposal</h5>
						</legend>
						
						<div class="row">
							<div class="form-group col-md-4">
								<label class="form-label" for="projectTitle"
									><b>Project Title</b></label
								>
								<span class="required-asterisk">*</span>
								<input
									formControlName="ProjectTitle"
									type="text"
									name="projectTitle"
									id="projectTitle"
									class="form-control"
									[ngClass]="{
										'is-invalid': submitted && !f1.ProjectTitle.valid
									}"
									placeholder="Project Title"
								/>
								<sub>(225 characters accepted) Character Count: {{ f1.ProjectTitle.value?.length || 0 }} / 225</sub>
								<span
									*ngIf="submitted && f1.ProjectTitle.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f1.ProjectTitle.errors.required"
										>This field is required!</small
									>
									<small
										class="form-text text-danger"
										*ngIf="f1.ProjectTitle.errors.pattern"
										>This field contain atleast one alphanumerical
										value!</small
									>
									<small class="form-text text-danger"
                                        *ngIf="f1.ProjectTitle.errors.maxlength">Maximum 225 characters allowed.</small>
								</span>
							</div>

							

                            <div class="form-group col-md-12">
                                <label class="form-label" for="summary"
                                    ><b>Summary (About a paragraph)</b></label
                                >
                                <span class="required-asterisk">*</span>
                                <textarea
                                    formControlName="Summary"
                                    type="text"
                                    name="summary"
                                    id="summary"
                                    style="height: 100px"
                                    class="form-control"
                                    [ngClass]="{
                                        'is-invalid': submitted && !f1.Summary.valid
                                    }"
                                    placeholder="Summary"
                                ></textarea>
                                <sub>(5000 characters accepted) Character Count: {{ f1.Summary.value?.length || 0 }} / 5000</sub>
                                <span
                                    *ngIf="submitted && f1.Summary.invalid"
                                    class="invalid-form"
                                >
                                    <small
                                        class="form-text text-danger"
                                        *ngIf="f1.Summary.errors.required"
                                        >This field is required!</small
                                    >
                                    <small class="form-text text-danger"
                                        *ngIf="f1.Summary.errors.maxlength">Maximum 5000 characters allowed.</small>
                                </span>
                            </div>
							
						</div>

						
					</fieldset>
                    <fieldset class="border" style="padding: 0.7rem" >
                        <legend class="w-auto">
							<h5 style="margin-top: 7px">Format</h5>
						</legend>
						<div class="text-center pb-2"> <h4 class="text-danger ">*Note: Please download all four files, follow instructions & upload complete application in one PDF (maximum limit upto 45 pages).</h4> </div>
                    <table class="table">
                        <tbody>
                            
                            <style>
								.proposal_download{background: #939393;
													padding: 10px;
													border-radius: 5px;
													color: #ffffff;
													margin-right: 8px;
													margin-left: 8px;}
								.proposal_download:hover{background-color: #00a2e2 !important; color: #ffffff;}
							</style>
                           
                            <tr>
                                <td scope="col" class="text-wrap">
                                    <!-- Annexure  &nbsp;&nbsp; -->
                                    <span>
									<strong>	Download </strong>
                                        <a class="proposal_download" href="{{documentURL}}/downloads/1-MNRE-Call-for-Proposals.pdf" target="_blank">
											Download File 1
                                        </a>
										<a class="proposal_download" href="{{documentURL}}/downloads/2-MNRE-Instructions-to-Indian-Project-Coordinator.pdf" target="_blank">
											Download File 2
									   </a>
									   <a class="proposal_download" href="{{documentURL}}/downloads/3-Guidelines.pdf" target="_blank">
										Download File 3
								    </a>
								   <a class="proposal_download" href="{{documentURL}}/downloads/4-Template-Part-B-project-description-full-proposal.pdf" target="_blank">
									Download File 4
							   </a>
                                    </span>
                                </td>
                                <td>
                                    
                                </td>
                                <td style="float: right; padding:20px 0 ;">
                                    <strong>Upload Document:</strong>
                                </td>
                                <td > 
                                    <div class="custom-file">
                                        <input
                                            type="file"
                                            class="custom-file-input"
                                            type="file"
                                            ng2FileSelect
                                            [uploader]="uploader"
                                            id="file-upload-single"
                                            
                                            (change) = "annexureFirstFileUpload($event)"
                                            
                                        />
                                        <label
                                            class="custom-file-label"
                                            id="SOELatter"
                                            for="file-upload-single"
                                            >{{ f1.DetailofAnnexureFirstFile.value }}</label
                                        >
                                    </div>
                                    <sup>(Accepted format is PDF, upto 10 MB)</sup>
									
                                    <span
                                    *ngIf="submitted && f1.DetailofAnnexureFirstFile.invalid"
                                    class="invalid-form"
                                >
                                    <small
                                        class="form-text text-danger"
                                        *ngIf="f1.DetailofAnnexureFirstFile.errors.required"
                                        >This field is required!</small
                                    >
                                    
                                </span>
                                </td>
								
       
                            </tr>

							<!-- <tr>

								<td scope="col" class="text-wrap">
									ANNEXURE-II &nbsp;&nbsp;
									<span>
										<a href="{{documentURL}}/documentUploads/AnnexureFile/ANNEXURE-II(A).pdf" target="_blank">
											Download Format
										</a>
									</span>
								</td>
								<td>
									
								</td>
								<td>
									
								</td>
								<td>
									<div class="custom-file">
										<input
											type="file"
											class="custom-file-input"
											type="file"
											ng2FileSelect
											[uploader]="uploader"
											id="file-upload-single"
											(click)="browsbuttonClick('annexureSecondFile')"
											(change) = "annexureSecondFileUpload($event)"
											
										/>
										<label
											class="custom-file-label"
											id="SOELatter"
											for="file-upload-single"
											>{{
												f2.DetailofAnnexureSecondFile.value
											}}</label
										>
									</div>
									<sup>(Accepted format is Upload PDF, upto 5 MB)</sup>
									<span
									*ngIf="submitted && f2.DetailofAnnexureSecondFile.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f2.DetailofAnnexureSecondFile.errors.required"
										>This field is required!</small
									>
									
								</span>
								</td>
	 
							</tr> -->
							<!-- <tr>
	<td scope="col" class="text-wrap">
		ANNEXURE-III &nbsp;&nbsp;
		<span>
			<a href="{{documentURL}}/documentUploads/AnnexureFile/ANNEXURE-II(B).pdf" target="_blank">
				Download Format
			</a>
		</span>
	</td>
	<td>
		
	</td>
	<td>
		
	</td>
	<td>
		<div class="custom-file">
		<input
			type="file"
			class="custom-file-input"
			type="file"
			ng2FileSelect
			[uploader]="uploader"
			id="file-upload-single"
			(click)="browsbuttonClick('annexureThirdFile')"
			(change) = "annexureThirdFileUpload($event)"
		/>
		<label
			class="custom-file-label"
			id="SOELatter"
			for="file-upload-single"
			>{{ f2.DetailofAnnexureThirdFile.value }}</label
		>
		</div>
		<sup>(Accepted format is Upload PDF, upto 5 MB)</sup>
		<span
									*ngIf="submitted && f2.DetailofAnnexureThirdFile.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f2.DetailofAnnexureThirdFile.errors.required"
										>This field is required!</small
									>
									
								</span>
	</td>
	
							</tr> -->

							<!-- <tr>
								<td scope="col" class="text-wrap">
									ANNEXURE-IV  &nbsp;&nbsp;
									<span>
										<a href="{{documentURL}}/documentUploads/AnnexureFile/ANNEXURE-II(C).pdf" target="_blank">
											Download Format
										</a>
									</span>
								</td>
								<td>
									
								</td>
								<td>
									
								</td>
								<td>
									<div class="custom-file">
										<input type="file" class="custom-file-input"
										type="file"
										ng2FileSelect
										[uploader]="uploader"
										id="file-upload-single"
										(click)="browsbuttonClick('annexureFourthFile')"
										(change) = "annexureFourthFileUpload($event)"
										/>
										<label
										class="custom-file-label"
										id="SOELatter"
										for="file-upload-single"
										>{{ f2.DetailofAnnexureFourthFile.value }}</label
										>
		
									</div>
									<sup>(Accepted format is Upload PDF, upto 5 MB)</sup>
									<span
									*ngIf="submitted && f2.DetailofAnnexureFourthFile.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f2.DetailofAnnexureFourthFile.errors.required"
										>This field is required!</small
									>
									
								</span>
								</td>
		
							</tr> -->
                            
                           
                           
                        </tbody>
                    </table>
                </fieldset>
					
<br>
									

									
									<div
										class="d-flex justify-content-between"
										style="margin-top: 7px"
									>
										<!-- <button
											(click)="horizontalWizardStepperPrevious()"
											class="btn btn-outline-secondary btn-prev"
											disabled
											rippleEffect
										>
											<i
												data-feather="arrow-left"
												class="align-middle mr-sm-25 mr-0"
											></i>
											<span class="align-middle d-sm-inline-block d-none"
												>Previous</span
											>
										</button> -->
										<button *ngIf="!hideButton"
											(click)="submitStep1()"
											type="submit"
											class="btn btn-primary btn-next"
											rippleEffect
										>
											<span class="align-middle d-sm-inline-block d-none"
												>Submit</span
											>
											<!-- <i
												data-feather="arrow-right"
												class="align-middle ml-sm-25 ml-0"
											></i> -->
										</button>
									</div>
								</form>
							</div>
							<div id="format2" class="content">
								<form [formGroup]="format2" autocomplete="off">
									<div class="content-header">
										<h5 class="mb-0">Proposal Format - 2</h5>
										<small class="text-muted">Fill-up the Details.</small>
									</div>

									

									<div
										class="row"
										id="table-responsive"
										style="margin-top: 5px"
									>
										<div class="form-group col-12">
											<div class="table-responsive table-bordered">
												<form
													[formGroup]="proposedCostForm"
													*ngIf="proposedCostForm"
												>
													<table class="table mb-0">
														<thead>
															<tr>
																<th scope="col" class="text-wrap" rowspan="2">
																	Proposed cost: (Details of equipment along
																	with justification to be provided separately
																	in the Format as per Annexure I)
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	SR. No.
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Item
																</th>
																<th scope="col" class="text-wrap"  rowspan="2">
																	Total Cost
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	style="text-align: center"
																	[attr.colspan]="noOfYeararray.length"
																>
																	Amount (Rs.)
																</th>
															</tr>

															<tr>
																<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
																	{{y.key}}
																</th>
															</tr>
														</thead>
														 <tbody formArrayName="proposedCostArray">
															<tr *ngFor="let item of proposedCostForm.controls.proposedCostArray.controls;let $index = index" [formGroupName]="$index">
																<td *ngIf="$index == 0" [attr.rowspan]="proposedCostForm.controls.proposedCostArray.length"></td>
																<td scope="col" class="text-wrap">
																	{{ $index + 1 }}.
																</td>
																<td scope="col" class="text-wrap">
																	<span>{{
																		proposedCostForm.controls[
																			"proposedCostArray"
																		].controls[$index].controls[
																			"proposedCostItemName"
																		].value
																	}}</span>
																</td>
																<td scope="col" class="text-wrap">
																	<input
																		type="hidden"
																		formControlName="proposedCostItemID"
																	/>
																	<span>{{
																		proposedCostForm.controls[
																			"proposedCostArray"
																		].controls[$index].controls["totalCost"]
																			.value
																	}}</span>
																</td>
																<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray; let $index1 = index1">
																	<input
																		class="form-control"
																		type="text"
																		curencyFormat
																		formControlName="{{y.label}}"
																		[mask]="
																			'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'
																		"
																		onKeyPress="if(this.value.length==15) return false;"
																		(change)="setAllFieldTotal($index)"
																	/>
																	
																</td>
														<tr>
															<td style="border-top: none"></td>
															<td scope="col" class="text-wrap">Total</td>
															<td scope="col" class="text-wrap"></td>
															<td scope="col" class="text-wrap">
																<span>{{ f2.allTotalCost.value }}</span>
															</td>
															<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray">
																<span>{{y.proposedCostTotal}}</span>
															</td>
														</tr>
													</table>
												</form>
												
											</div>
										</div>
									</div>
									
									<!-- <div class="d-flex justify-content-between">
										<button
										 *ngIf="!hideButton"
											type="button" 
											(click)="horizontalWizardStepperPrevious()"
											class="btn btn-primary btn-prev"
											rippleEffect
										>
											<i
												data-feather="arrow-left"
												class="align-middle mr-sm-25 mr-0"
											></i>
											<span class="align-middle d-sm-inline-block d-none"
												>Previous</span
											>
										</button>
										<button
											(click)="submitStep2()"
											class="btn btn-primary btn-next"
											rippleEffect
										>
											<span class="align-middle d-sm-inline-block d-none"
												>Submit</span
											>
											<i
												data-feather="arrow-right"
												class="align-middle ml-sm-25 ml-0"
											></i>
										</button>
									</div> -->
								</form>
							</div>
							<div id="format3" class="content">
								<form [formGroup]="format3" autocomplete="off">
									<div class="content-header">
										<h5 class="mb-0">
											Details of Costs of Various Components and Justification
										</h5>
										<small class="text-muted">Fill-up the Details.</small>
									</div>
									<div class="row" id="table-responsive">
										<span class="mb-2">a). Cost of Equipment</span>
										<div class="form-group col-12">
											<div class="table-responsive table-bordered">
												<form [formGroup]="equipmentForm" *ngIf="equipmentForm">
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th scope="col" class="text-wrap">Action</th>
																<th scope="col" class="text-wrap">Sr.</th>
																<th scope="col" class="text-wrap">
																	Name of the Equipment along with make & model
																</th>
																<th scope="col" class="text-wrap">
																	Imported/ Indigenous
																</th>
																<th scope="col" class="text-wrap">
																	Estimated Costs (in INR Currency also for
																	imported equipment)*
																</th>
																<th scope="col" colspan="2" class="text-wrap">
																	Justification
																</th>
															</tr>
														</thead>
														<tbody formArrayName="equipmentArray">
															<tr
																*ngFor="
																	let item of equipmentForm.controls
																		.equipmentArray.controls;
																	let $index = index
																"
																[formGroupName]="$index"
															>
																<td>
																	<i
																		class="fa fa-trash fa-2x"
																		(click)="deleteEquipmentRow($index)"
																		title="Delete"
																		style="cursor: pointer"
																	></i>
																</td>
																<td scope="col" class="text-wrap">
																	{{ $index + 1 }}.
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text"
																		formControlName="equipmentName"
																		[ngClass]="{
																			'is-invalid':
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'equipmentName'
																				].touched &&
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'equipmentName'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			equipmentForm.controls['equipmentArray']
																				.controls[$index].controls[
																				'equipmentName'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'equipmentName'
																				].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'equipmentName'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										equipmentForm.controls['equipmentArray']
											.controls[$index].controls[
											'equipmentName'
										].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'equipmentName'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text"
																		formControlName="importedIndigenous"
																		[ngClass]="{
																			'is-invalid':
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'importedIndigenous'
																				].touched &&
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'importedIndigenous'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			equipmentForm.controls['equipmentArray']
																				.controls[$index].controls[
																				'importedIndigenous'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'importedIndigenous'
																				].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'importedIndigenous'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										equipmentForm.controls['equipmentArray']
											.controls[$index].controls[
											'importedIndigenous'
										].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'importedIndigenous'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="estimatedCost"
																		[ngClass]="{
																			'is-invalid':
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'estimatedCost'
																				].touched &&
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'estimatedCost'
																				].invalid
																		}"
																		[mask]="
																			'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'
																		"
																		onKeyPress="if(this.value.length==15) return false;"
																	/>
																	<span
																		*ngIf="
																			equipmentForm.controls['equipmentArray']
																				.controls[$index].controls[
																				'estimatedCost'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'estimatedCost'
																				].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'estimatedCost'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																	</span>
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text"
																		formControlName="justification"
																		[ngClass]="{
																			'is-invalid':
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'justification'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			equipmentForm.controls['equipmentArray']
																				.controls[$index].controls[
																				'justification'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										equipmentForm.controls['equipmentArray']
											.controls[$index].controls[
											'justification'
										].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td scope="col" class="text-wrap">
																	<div class="custom-file">
																		<input
																			type="file"
																			class="custom-file-input"
																			type="file"
																			ng2FileSelect
																			[uploader]="uploader"
																			id="file-upload-single"
																			formControlName="file"
																			(click)="
																				browsArrayFileObject(
																					'costEquipmentFileList',
																					$index
																				)
																			"
																			(change)="
																				onFileChange($event,'costEquipmentFileList',$index,25)
																			"
																		/>
																		<label
																			class="custom-file-label"
																			id="SOELatter"
																			for="file-upload-single"
																			>{{
																				equipmentForm.controls["equipmentArray"]
																					.controls[$index].controls["fileName"]
																					.value
																			}}</label
																		>
																	</div>
																</td>
																<td *ngIf="(equipmentForm.controls['equipmentArray'].controls[$index].controls['costEquipmentFile'].value != '')">
																	<a href="{{equipmentForm.controls['equipmentArray'].controls[$index].controls['costEquipmentFile'].value}}" target="_blank"><i
																		class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
																		title="Download Document"></i></a>
																</td>
															</tr>
															<tr>
																<td>
																	<i
																		class="fa fa-plus fa-2x"
																		(click)="addEquipmentRow()"
																		title="Add"
																		style="cursor: pointer"
																	></i>
																</td>
															</tr>
														</tbody>
													</table>
												</form>
											</div>
											<span
												>*Including transport, insurance and installation
												charges.</span
											>
										</div>
									</div>

									

									

									<!-- <div class="d-flex justify-content-between">
										<button
											type="button"
											(click)="horizontalWizardStepperPrevious()"
											class="btn btn-primary btn-prev"
											rippleEffect
										>
											<i
												data-feather="arrow-left"
												class="align-middle mr-sm-25 mr-0"
											></i>
											<span class="align-middle d-sm-inline-block d-none"
												>Previous</span
											>
										</button>
										<button
											(click)="submitStep3()"
											class="btn btn-primary btn-next"
											rippleEffect
										>
											<span class="align-middle d-sm-inline-block d-none"
												>Save & Next</span
											>
											<i
												data-feather="arrow-right"
												class="align-middle ml-sm-25 ml-0"
											></i>
										</button>
									</div> -->
								</form>
							</div>
							<div id="format4" class="content">
								<form [formGroup]="format4" autocomplete="off">
									<div class="content-header">
										<h5 class="mb-0">Proposal Format - 4</h5>
										<small class="text-muted">Fill-up the Details.</small>
									</div>
									<div class="row" id="table-responsive">
										<span class="mb-2">d). Travel Cost</span>
										<div class="form-group col-12">
											<div class="table-responsive table-bordered">
												<form [formGroup]="travelForm" *ngIf="travelForm">
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th scope="col" class="text-wrap" rowspan="2">
																	Action
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Sr.
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Travel (Domestic/ International)
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Justification
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	style="text-align: center"
																	[attr.colspan]="dynamicColumnCount"
																>
																	Amount (Rs.)
																</th>
															</tr>
															<tr>
																<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
																	{{y.key}}
																</th>
																<th scope="col" class="text-wrap">Total</th>
															</tr>
														</thead>
														<tbody formArrayName="travelArray">
															<tr
																*ngFor="
																	let item of travelForm.controls.travelArray
																		.controls;
																	let $index = index
																"
																[formGroupName]="$index"
															>
																<td>
																	<i
																		class="fa fa-trash fa-2x"
																		(click)="deleteTravelRow($index)"
																		title="Delete"
																		style="cursor: pointer"
																	></i>
																</td>
																<td scope="col" class="text-wrap">
																	{{ $index + 1 }}.
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text"
																		formControlName="title"
																		[ngClass]="{
																			'is-invalid':
																				travelForm.controls['travelArray']
																					.controls[$index].controls['title']
																					.touched &&
																				travelForm.controls['travelArray']
																					.controls[$index].controls['title']
																					.invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			travelForm.controls['travelArray']
																				.controls[$index].controls['title']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				travelForm.controls['travelArray']
																					.controls[$index].controls['title']
																					.touched &&
																				travelForm.controls[
																					'travelArray'
																				].controls[$index].controls[
																					'title'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										travelForm.controls['travelArray']
											.controls[$index].controls['title']
											.touched &&
											travelForm.controls[
											'travelArray'
											].controls[$index].controls[
											'title'
											].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text"
																		formControlName="justification"
																		[ngClass]="{
																			'is-invalid':
																				travelForm.controls['travelArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				travelForm.controls['travelArray']
																					.controls[$index].controls[
																					'justification'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			travelForm.controls['travelArray']
																				.controls[$index].controls[
																				'justification'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				travelForm.controls['travelArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				travelForm.controls[
																					'travelArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										travelForm.controls['travelArray']
											.controls[$index].controls[
											'justification'
										].touched &&
																				travelForm.controls[
																					'travelArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td style="min-width: 120px" *ngFor="let y of noOfYeararray; let $index1 = index1">
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="{{y.label}}"
																		(change)="setTravelCostTotal($index)"
																		[mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'"
																		onKeyPress="if(this.value.length==15) return false;"
																	/>
																</td>
																<td style="min-width: 120px">
																	<span>{{
																		travelForm.controls["travelArray"].controls[
																			$index
																		].controls["total"].value
																	}}</span>
																</td>
															</tr>
															<tr>
																<td>
																	<i
																		class="fa fa-plus fa-2x"
																		(click)="addTravelRow()"
																		title="Add"
																		style="cursor: pointer"
																	></i>
																</td>
															</tr>
														</tbody>
													</table>
												</form>
											</div>
										</div>
									</div>
									<div class="d-flex justify-content-between">
										<!-- <button
											type="button"
											(click)="horizontalWizardStepperPrevious()"
											class="btn btn-primary btn-prev"
											rippleEffect
										>
											<i
												data-feather="arrow-left"
												class="align-middle mr-sm-25 mr-0"
											></i>
											<span class="align-middle d-sm-inline-block d-none"
												>Previous</span
											>
										</button> -->
										<!-- <button (click)="horizontalWizardStepperNext(format4)" class="btn btn-primary btn-next"
						rippleEffect>
						<span class="align-middle d-sm-inline-block d-none">Save & Next</span>
						<i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
					</button> -->
										<!-- <button
											class="btn btn-success btn-submit"
											[disabled]="isDisabled"
											rippleEffect
											(click)="onSubmit()"
										>
											Submit
										</button> -->
									</div>
								</form>
							</div>
							<!-- <div id="format5" class="content">
				<form [formGroup]="format5" autocomplete="off" (ngSubmit)="onSubmit()">
					<div class="content-header">
					<h5 class="mb-0">Certificate from the Principal Investigator and Grantee organization (On the letter
						head of the Organization)</h5>
					</div>
					<div class="row">
					<div class="form-group col-md-6"></div>
					<div class="form-group col-md-6"></div>
					</div>
					<div class="d-flex justify-content-between">
					<button type="button" (click)="horizontalWizardStepperPrevious()" class="btn btn-primary btn-prev"
						rippleEffect>
						<i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
						<span class="align-middle d-sm-inline-block d-none">Previous</span>
					</button>
					<button class="btn btn-success btn-submit" rippleEffect (click)="onSubmit()">Submit</button>
					</div>
				</form>
				</div> -->
						</div>
					</div>
				</div>
			<!-- </div> -->
		</section>
	</div>
</div>

